import { useMutation } from "@apollo/client/react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";

import { ModuleShareNewFormFields } from "../types";
import { processValuesBeforeSubmit } from "./utils";
import { SHARE_MODULE } from "./gql";

type UseShareModuleOptions = {
  moduleId: string;
};

export const useShareModule = ({ moduleId }: UseShareModuleOptions) => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const [shareModule, { loading }] = useMutation(SHARE_MODULE, {
    refetchQueries: ["GetModuleSettings"],
    awaitRefetchQueries: true,
  });

  const handleShareModule = async (data: ModuleShareNewFormFields, onSuccess?: () => void) => {
    const preparedData = processValuesBeforeSubmit(data);

    const input = {
      accounts: preparedData.sharedAccounts?.map(({ value }) => value) || [],
      spaces: preparedData.sharedSpaces?.map(({ value }) => value) || [],
    };
    return shareModule({ variables: { id: moduleId, input } })
      .then(({ data }) => {
        if (data?.moduleShare) {
          if (onSuccess) {
            onSuccess();
          } else {
            reportSuccess({ message: "Module shared successfully" });
          }
        }
      })
      .catch((e) => {
        onError(e);
        throw e;
      });
  };

  return { shareModule: handleShareModule, loading };
};
